import { createFileRoute } from "@tanstack/react-router";
import { actions } from "../../lib/actions.ts";
import { ListsLayout } from "../../screens/lists/ListsLayout.tsx";

/** `/lists`: the layout around the index and the list page (the Lists sidebar beside an open list). */
export const Route = createFileRoute("/_app/lists")({
  loader: ({ context }) =>
    context.queryClient.prefetchQuery(actions.queryOptions("lists.index", { archived: false })),
  component: ListsLayout,
});
